module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"priority":"Priority","hostname":"Hostname"},"de":{"priority":"Priorität","hostname":"Hostname"}}')
  delete Component.options._Ctor
}
